import React from "react";
import { useNavigate } from "react-router-dom";

const EffortlessCryptoTrading = () => {
  const navigate = useNavigate();
  return (
    <section className="bg-[linear-gradient(to_bottom,#302571,#201a48)] mt-24">
      <div className="w-full max-w-[1320px] mx-auto px-5 lg:px-10 pt-28 pb-28">
        <h2 className="text-2xl lg:text-[36px] font-bold bg-[#D9D9D9] text-[#2F256F] p-2 px-8 w-fit rounded-full mx-auto">
          Effortless crypto trading in 4 simple steps!
        </h2>

        <div className="grid lg:grid-cols-4 gap-12 mt-14 relative">
          <div className="absolute bg-[linear-gradient(to_bottom,rgba(255,255,255,0)_0%,rgba(255,255,255,1)_36%,rgba(255,255,255,1)_63%,rgba(255,255,255,0)_100%)] lg:bg-[linear-gradient(to_right,rgba(255,255,255,0)_0%,rgba(255,255,255,1)_36%,rgba(255,255,255,1)_63%,rgba(255,255,255,0)_100%)] max-lg:left-[1.5rem] max-lg:top-[2.5rem] max-lg:h-[85%] w-[1px] lg:w-full lg:h-[1px] lg:top-[1.5rem]"></div>
          <div className="flex lg:flex-col items-center gap-5 lg:gap-12 relative z-[1]">
            <span className="max-lg:w-full max-lg:max-w-[50px] w-[50px] h-[50px] bg-[#007A78] flex justify-center items-center text-[36px] rounded-full text-white font-bold">
              1
            </span>
            <div className="text-[#E1E1E1]">
              <h4 className="text-xl font-semibold">Choose Your Bot & Plan</h4>
              <p className="text-base text-[#E1E1E1]">
                Select the bot that fits your strategy and risk level.
              </p>
            </div>
          </div>
          <div className="flex lg:flex-col items-center gap-5 lg:gap-12 relative z-[1]">
            <span className="max-lg:w-full max-lg:max-w-[50px] w-[50px] h-[50px] bg-[#007A78] flex justify-center items-center text-[36px] rounded-full text-white font-bold">
              2
            </span>
            <div className="text-[#E1E1E1]">
              <h4 className="text-xl font-semibold">Connect Your Exchange</h4>
              <p className="text-base text-[#E1E1E1]">
                Secure API connection with top exchanges.
              </p>
            </div>
          </div>
          <div className="flex lg:flex-col items-center gap-5 lg:gap-12 relative z-[1]">
            <span className="max-lg:w-full max-lg:max-w-[50px] w-[50px] h-[50px] bg-[#007A78] flex justify-center items-center text-[36px] rounded-full text-white font-bold">
              3
            </span>
            <div className="text-[#E1E1E1]">
              <h4 className="text-xl font-semibold">Let It Run</h4>
              <p className="text-base text-[#E1E1E1]">
                Watch your bot trade automatically and grow your portfolio.
              </p>
            </div>
          </div>
          <div className="flex lg:flex-col items-center gap-5 lg:gap-12 relative z-[1]">
            <span className="max-lg:w-full max-lg:max-w-[50px] w-[50px] h-[50px] bg-[#007A78] flex justify-center items-center text-[36px] rounded-full text-white font-bold">
              4
            </span>
            <div className="text-[#E1E1E1]">
              <h4 className="text-xl font-semibold">Adjust Anytime</h4>
              <p className="text-base text-[#E1E1E1]">
                Change strategies or switch bots as your needs evolve.
              </p>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 justify-between mt-24">
          <div>
            <div>
              <h4 className="font-bold text-[42px] text-white leading-[1.1]">
                Empower your crypto journey: Learn, Trade, Grow.
              </h4>
              <p className="text-white/70 mt-6 text-base max-w-[500px]">
                Xenorize isn’t just about automation — it’s about making you a
                smarter trader. Access structured learning paths, practical
                insights, and a thriving community to accelerate your growth.
              </p>
              <button
                className="w-fit rounded-full relative overflow-hidden !py-3 !font-bold !text-lg bg-teal-700 hover:bg-teal-800 mt-12 px-8"
                onClick={() => navigate("/signup")}
              >
                Start Journey
              </button>
            </div>

            <div className="w-full mt-12 pointer-events-none">
              <img
                src="/images/laptop-landing-page.png"
                alt=""
                className="lg:w-[calc(100%+14rem)] max-lg:w-[calc(100%+4rem)] ml-[-5rem] max-w-[700px] lg:max-w-[900px] lg:ml-[-13rem]"
              />
            </div>
          </div>

          <div className="lg:ml-auto max-lg:mt-12 flex flex-col gap-6 pointer-events-none">
            <div className="relative p-6 rounded-xl border border-[#DDE1E6] bg-[#534984]/40 w-full lg:max-w-[400px]">
              {/* line */}
              <img
                src="/images/line-1-empower.svg"
                alt=""
                className="lg:absolute max-xl:hidden right-[calc(100%+.5rem)] top-[60%] w-full max-w-[300px]"
              />
              {/* end line */}
              <svg
                width="36"
                height="36"
                viewBox="0 0 44 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 30V20.8462C2 20.2939 2.44772 19.8462 3 19.8462H15.069C15.6213 19.8462 16.069 19.3984 16.069 18.8462V12.7596C16.069 12.2073 16.5167 11.7596 17.069 11.7596H28.0345C28.5868 11.7596 29.0345 11.3119 29.0345 10.7596V3C29.0345 2.44772 29.4822 2 30.0345 2H41C41.5523 2 42 2.44772 42 3V30C42 30.5523 41.5523 31 41 31H3C2.44772 31 2 30.5523 2 30Z"
                  stroke="white"
                  stroke-width="4"
                />
              </svg>
              <h4 className="text-xl font-bold text-white mt-6">
                Structured Learning Paths
              </h4>
              <p className="text-sm text-white/70">
                Build your skills step-by-step with our Trading and Investment
                Tracks.
              </p>
            </div>
            <div className="relative p-6 rounded-xl border border-[#DDE1E6] bg-[#534984]/40 w-full lg:max-w-[400px]">
              {/* line */}
              <img
                src="/images/line-2-empower.svg"
                alt=""
                className="lg:absolute max-xl:hidden right-[calc(100%+.5rem)] top-[60%] w-full max-w-[300px]"
              />
              {/* end line */}
              <svg
                width="36"
                height="36"
                viewBox="0 0 43 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="14.8367"
                  cy="14.7825"
                  r="12.7825"
                  stroke="white"
                  stroke-width="4"
                />
                <rect
                  x="25.9121"
                  y="18.7539"
                  width="19.71"
                  height="4.9275"
                  rx="2"
                  transform="rotate(29.9985 25.9121 18.7539)"
                  fill="white"
                />
              </svg>
              <h4 className="text-xl font-bold text-white mt-6">
                Testing Features
              </h4>
              <p className="text-sm text-white/70">
                Test your bot strategies with paper trading, back testing, and
                forward testing before going live.
              </p>
            </div>
            <div className="relative p-6 rounded-xl border border-[#DDE1E6] bg-[#534984]/40 w-full lg:max-w-[400px]">
              {/* line */}
              <img
                src="/images/line-3-empower.svg"
                alt=""
                className="lg:absolute max-xl:hidden right-[calc(100%+.5rem)] top-[25%] w-full max-w-[300px]"
              />
              {/* end line */}

              <svg
                width="36"
                height="36"
                viewBox="0 0 44 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27 10H11.4998C9.89943 10.208 6.48718 11.4147 5.64146 14.5771C4.79574 17.7394 2.99936 23.967 2.20689 26.6855C1.73666 28.4192 1.76525 32.0865 5.64146 32.8854C10.4867 33.884 12.2927 28.0586 13.0415 27.0184C13.7903 25.9781 13.9225 24.2305 17.2261 24.1473C19.8689 24.0807 21.6162 24.1196 22.1594 24.1473"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <path
                  d="M38.5313 14.5879C39.3369 17.7483 41.0481 23.9722 41.8029 26.689C42.2508 28.4217 42.2236 32.0867 38.5313 32.8852C33.916 33.8832 32.1957 28.0613 31.4825 27.0217C30.7692 25.9821 30.6433 24.2355 27.4965 24.1524C24.979 24.0858 22.5175 24.1246 22 24.1524"
                  stroke="white"
                  stroke-width="4"
                  stroke-linecap="round"
                />
                <path
                  d="M34.0561 2.69748C34.3686 1.80451 35.6314 1.80451 35.9439 2.69748L36.3373 3.82167C36.4776 4.22279 36.8562 4.49139 37.2811 4.49139H38.3871C39.3737 4.49139 39.7642 5.76862 38.9464 6.32037L38.1822 6.8359C37.8055 7.09005 37.6475 7.56624 37.7976 7.99516L38.119 8.91364C38.4369 9.82207 37.4137 10.6112 36.6158 10.0729L35.5593 9.36009C35.2213 9.13207 34.7787 9.13207 34.4407 9.36009L33.3842 10.0729C32.5863 10.6112 31.5631 9.82207 31.881 8.91364L32.2024 7.99516C32.3525 7.56624 32.1945 7.09005 31.8178 6.8359L31.0536 6.32037C30.2358 5.76862 30.6263 4.49139 31.6129 4.49139H32.7189C33.1438 4.49139 33.5224 4.22279 33.6627 3.82167L34.0561 2.69748Z"
                  fill="white"
                />
                <rect x="12" y="16" width="6" height="2" rx="1" fill="white" />
                <rect
                  x="16"
                  y="14"
                  width="6"
                  height="2"
                  rx="1"
                  transform="rotate(90 16 14)"
                  fill="white"
                />
              </svg>

              <h4 className="text-xl font-bold text-white mt-6">
                Gamified Experience
              </h4>
              <p className="text-sm text-white/70">
                Earn rewards as you complete lessons and challenges.
              </p>
            </div>
            <div className="relative p-6 rounded-xl border border-[#DDE1E6] bg-[#534984]/40 w-full lg:max-w-[400px]">
              {/* line */}
              <img
                src="/images/line-4-empower.svg"
                alt=""
                className="lg:absolute max-xl:hidden right-[calc(100%+.5rem)] bottom-[70%] w-full max-w-[300px]"
              />
              {/* end line */}

              <svg
                width="36"
                height="36"
                viewBox="0 0 47 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1_1077_7100" fill="white">
                  <path d="M33 0C40.732 6.12045e-07 47 6.26801 47 14V16C47 23.732 40.732 30 33 30H19.5421C19.1849 30 18.8548 30.1906 18.6762 30.4999L16.366 34.5004C15.9811 35.167 15.0189 35.167 14.634 34.5004L12.1902 30.2686C12.0374 30.0039 11.771 29.8258 11.4704 29.7709C4.94596 28.5803 2.86162e-08 22.8682 0 16V14C0 6.26801 6.26801 0 14 0H33Z" />
                </mask>
                <path
                  d="M33 0L33 -4H33V0ZM47 14L51 14L47 14ZM0 16L-4 16L0 16ZM12.1902 30.2686L15.6541 28.2683L12.1902 30.2686ZM11.4704 29.7709L10.7523 33.706L11.4704 29.7709ZM16.366 34.5004L12.9021 32.5001L16.366 34.5004ZM14.634 34.5004L11.1701 36.5008L14.634 34.5004ZM18.6762 30.4999L15.2122 28.4996L18.6762 30.4999ZM33 0L33 4C38.5228 4 43 8.47715 43 14L47 14L51 14C51 4.05887 42.9411 -4 33 -4L33 0ZM47 14H43V16H47H51V14H47ZM47 16H43C43 21.5228 38.5228 26 33 26V30V34C42.9411 34 51 25.9411 51 16H47ZM33 30V26H19.5421V30V34H33V30ZM18.6762 30.4999L15.2122 28.4996L12.9021 32.5001L16.366 34.5004L19.8299 36.5007L22.1401 32.5002L18.6762 30.4999ZM14.634 34.5004L18.0979 32.5001L15.6541 28.2683L12.1902 30.2686L8.7263 32.269L11.1701 36.5008L14.634 34.5004ZM11.4704 29.7709L12.1885 25.8359C7.53032 24.9858 4 20.9012 4 16L0 16L-4 16C-4 24.8353 2.3616 32.1747 10.7523 33.706L11.4704 29.7709ZM0 16H4V14H0H-4V16H0ZM0 14H4C4 8.47715 8.47715 4 14 4V0V-4C4.05887 -4 -4 4.05887 -4 14H0ZM14 0V4H33V0V-4H14V0ZM12.1902 30.2686L15.6541 28.2683C14.8765 26.9217 13.5676 26.0876 12.1885 25.8359L11.4704 29.7709L10.7523 33.706C9.97443 33.564 9.19823 33.0862 8.7263 32.269L12.1902 30.2686ZM16.366 34.5004L12.9021 32.5001C14.0568 30.5004 16.9431 30.5004 18.0979 32.5001L14.634 34.5004L11.1701 36.5008C13.0947 39.8335 17.9053 39.8335 19.8299 36.5007L16.366 34.5004ZM19.5421 30V26C17.756 26 16.1055 26.9528 15.2122 28.4996L18.6762 30.4999L22.1401 32.5002C21.6041 33.4283 20.6138 34 19.5421 34V30Z"
                  fill="white"
                  mask="url(#path-1-inside-1_1077_7100)"
                />
                <circle cx="14" cy="15" r="3" fill="white" />
                <circle cx="24" cy="15" r="3" fill="white" />
                <circle cx="34" cy="15" r="3" fill="white" />
              </svg>

              <h4 className="text-xl font-bold text-white mt-6">
                Community-Driven Growth
              </h4>
              <p className="text-sm text-white/70">
                Learn and share with like-minded traders.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EffortlessCryptoTrading;
